import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { IClientAdhesionList, emptyClientAdhesionList } from '../../../model/client-adhesion-list';
import { emptyClientAdhesion, IClientAdhesion } from '../../../model/client-adhesion';
import { NgbModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { ClientAdhesionService } from '../../../services/client-adhesion.service';
import { of } from 'rxjs/observable/of';
import { InvoicingServiceService } from '../../../services/invoicing-service.service';
import { emptyPerson, IPerson } from '../../../model/person';
import { LoginService } from '../../../services/login.service';
import { emptyInvoicingService, IInvoicingService } from '../../../model/invoicing-service';
import { emptyDire, IDire } from '../../../model/dire';
import { emptyClientAdhesionFilter, IClientAdhesionFilter } from '../../../model/client-adhesion-filter';
import { emptyClientFilter, IClientFilter } from '../../../model/client-filter';
import { IHttpErrorsResponse } from '../../../model/http-errors-response';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DireService } from '../../../services/dire.service';
import { Subject } from 'rxjs/Subject';
import { SpinnerService } from '../../../services/spinner.service';
import { IDireList, emptyIDireList } from "../../../model/dire-list";
import { RechargeDireService } from "../../../services/recharge-dire.service";
import { Subscription } from "rxjs";
import { ClientService } from '../../../services/client.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cli-adhesion-list',
  templateUrl: './cli-adhesion-list.component.html',
  styleUrls: ['./cli-adhesion-list.component.css']
})
export class CliAdhesionListComponent implements OnInit {

  /**
   * List of adhesion request of client
   */
  clientAdhesionList: IClientAdhesionList = emptyClientAdhesionList;

  /**
   *
   * @type {IClientAdhesion}
   */
  clientAdhesion: IClientAdhesion = emptyClientAdhesion;

  /**
   *
   * @type {IInvoicingService}
   */
  invoicingService: IInvoicingService = emptyInvoicingService;

  /**
   *
   * @type {IDire}
   */
  dire: IDire = emptyDire;

  /**
   * Current User
   */
  currentUser: IPerson = emptyPerson;

  /**
   *
   * @type {IClientAdhesionFilter}
   */
  filter: IClientAdhesionFilter = emptyClientAdhesionFilter;

  /**
   *
   * @type {IClientFilter}
   */
  clientFilter: IClientFilter = emptyClientFilter;

  /**
   *
   * @type {boolean}
   */
  newAdhesionStep1: boolean = false;

  /**
   *
   * @type {boolean}
   */
  newAdhesionStep2: boolean = false;

  /**
   *
   * @type {boolean}
   */
  newAdhesionStep3: boolean = false;

  /**
   *
   * @type {boolean}
   */
  newMultipleAdhesion: boolean = false;

  /**
   *
   * @type {boolean}
   */
  checkboxDireList: boolean = false;

  /**
   *
   * @type {boolean}
   */
  checkboxDireListAdded: boolean = false;

  /**
   *
   * @type {IDireList}
   */
  direList: IDireList = emptyIDireList;

  /**
   *
   * @type {IDireList}
   */
  direListAdded: any[] = [];

  /**
   *
   * @type {IDireList}
   */
  selectedLeftValue: any[] = [];

  /**
   *
   * @type {IDireList}
   */
  selectedRightValue: any[] = [];

  /**
   * @type {IHttpErrorsResponse}
   */
  errors: IHttpErrorsResponse[];

  /**
   * Search ESF by a typeahead
   */
  modelBs: any;
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);

  /**
   * Search Dire by a typeahead
   */
  searchingDire = false;

  /**
   *
   * @type {Subject<any>}
   */
  subject: Subject<string> = new Subject();

  /**
   *
   * @type {Subject<any>}
   */
  subjectAdhesion: Subject<string> = new Subject();

  /**
   *
   * @type {number}
   */
  itemsPerPage: number = 5;

  /**
   *
   * @type {number}
   */
  p: number = 0;

  adhesionStatusMapping = {
        P: 'cli.adhesionList.labelStatusP',
        A: 'cli.adhesionList.labelStatusA',
        C: 'cli.adhesionList.labelStatusC',
        CD: 'cli.adhesionList.labelStatusCD'
    };

    /**
   * Contenido del panel modal para actualizar un receiver
   */
  @ViewChild('updateClientAdhesion')
  private updateClientAdhesion: TemplateRef<any>;

  /**
   * Contenido del panel modal para crear una autorización
   */
  @ViewChild('confirmAuthorization')
  private confirmAuthorization: TemplateRef<any>;

  /**
   * Contenido del panel modal para seleccionar unidad dire
   */
  @ViewChild('openAddDIRe')
  private openAddDIRe: TemplateRef<any>;

  subscriptionRecharge: Subscription;

  /**
   *
   * @param {ClientAdhesionService} clientAdhesionService
   * @param {InvoicingServiceService} invoicingServiceService
   * @param {DireService} direService
   * @param {LoginService} loginService
   * @param {ToastsManager} toastr
   * @param {TranslateService} translate
   * @param {SpinnerService} spinnerService
   * @param {NgbModal} modalService
   * @param {RechargeDireService} rechargeDireService
   */
  constructor(
              private clientAdhesionService: ClientAdhesionService,
              private invoicingServiceService: InvoicingServiceService,
              private direService: DireService,
              private loginService: LoginService,
              private toastr: ToastsManager,
              private translate: TranslateService,
              private spinnerService: SpinnerService,
              private modalService: NgbModal,
              private rechargeDireService: RechargeDireService,
              private clientService: ClientService,
              private router: Router
  ) {
     this.currentUser = loginService.getPerson();
     this.clientService.getClient(this.getPerson().identifier)
      .subscribe(
        res => {
          console.log('res '+res);
        },
        error => {
          this.router.navigate(['/cliente/nuevo-cliente']);
        });

  }

  /**
   * ngOnInit
   */
  ngOnInit() {
    this.searchClientAdhesion();
    this.subject.debounceTime(400).subscribe(() => {
      this.searchClientAdhesion();
    });


    this.subscriptionRecharge = this.rechargeDireService.rechargeClient$
      .subscribe(() => {
        this.createMultipleAdhesion();
      });
  }

  /**
   * Search of bs by typeahead
   */
  searchBs = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => this.searching = true)
      .switchMap(term => term.length < 3 ? [] :
         this.invoicingServiceService.searchInvoicingServices(term)
          .do(() => {
            this.searchFailed = false;
          })
          .catch(() => {
            this.searchFailed = true;
            return of([]);
          }))
      .do(() => this.searching = false)
      .merge(this.hideSearchingWhenUnsubscribed);

  /**
   *
   * @param {{name: string}} x
   */
  formatter = (x: {name: string, tradeName: string, identifier: string, code: string}) => (('identifier' in x) ? x.identifier : x.code) + ' - ' + (('tradeName' in x) ? x.tradeName : x.name);

  /**
   *
   * @param {NgbTypeaheadSelectItemEvent} event
   */
  onSelectBsItem(event: NgbTypeaheadSelectItemEvent): void {
    event.preventDefault();
    this.modelBs = event.item.tradeName;
    this.clientAdhesion.invoicingServiceIdentifier = event.item.identifier;
  }

  saveClientAdhesion() {
    let results = [];
    let client = CliAdhesionListComponent.createDefaultAdhesion();

    this.direListAdded.forEach(item => {
      client.direCode = item.code;
      client.invoicingServiceIdentifier = this.clientAdhesion.invoicingServiceIdentifier;

      this.clientAdhesionService.saveClientAdhesion(client, this.getPerson())
        .subscribe((res) => {
          this.clientAdhesionList.items.unshift(res);
          this.clearNewAdhesion();
        }, error => {
          results.push(error);
        });
    });

    this.errors = results;
  }

  searchClientAdhesion() {
    this.clientAdhesionService.getClientAdhesions(this.currentUser.identifier, this.filter)
      .subscribe(res => {
        this.clientAdhesionList = res as IClientAdhesionList
      })
  }

  clearNewAdhesion() {
    this.newAdhesionStep1 = false;
    this.newAdhesionStep2 = false;
    this.newAdhesionStep3 = false;
    this.newMultipleAdhesion = false;
    this.modelBs = '';
    this.clientFilter.searchedText = '';
    this.clientFilter.searchedTextParent = '';
    this.clientAdhesion.direCode = '';
    this.clientAdhesion.invoicingServiceIdentifier = '';
    this.direList = emptyIDireList;
    this.direListAdded = [];
    this.errors = null;
  }

  showStep1() {
    this.newAdhesionStep1 = true;
    this.newAdhesionStep2 = false;
    this.newAdhesionStep3 = false;
    this.selectedLeftValue = [];
    this.selectedRightValue = [];
    this.direList = emptyIDireList;
    this.direListAdded = [];
  }

  showStep2() {
    if (this.newAdhesionStep3 == false) {
      this.createMultipleAdhesion();
      this.subjectAdhesion.debounceTime(400).subscribe(() => {
        this.createMultipleAdhesion();
      });
    }

    this.newAdhesionStep1 = false;
    this.newAdhesionStep2 = true;
    this.newAdhesionStep3 = false;
    this.errors = null;
  }

  showStep3() {
    this.newAdhesionStep1 = false;
    this.newAdhesionStep2 = false;
    this.newAdhesionStep3 = true;
  }

  createMultipleAdhesion() {
    this.newAdhesionStep1 = false;
    this.newMultipleAdhesion = true;
    this.spinnerService.setSpinner(true);
    this.clientFilter.isReceiver = 'n';
    this.direService.searchDireUnits(this.currentUser.identifier, this.clientFilter)
      .subscribe(res => {
          this.spinnerService.setSpinner(false);
          this.direList = res;
        },
        error => (this.spinnerService.setSpinner(false)));
  }

  checkAll(e, side) {
    if (side == 'Left') {
      this.direList.items.forEach(item => {
        item.selected = e.target.checked;
        this.checkOrUncheck(e, item, side);
      });
    } else {
      this.direListAdded.forEach(item => {
        item.selected = e.target.checked;
        this.checkOrUncheck(e, item, side);
      });
    }
  }

  checkOrUncheck(e, dire, side) {
    let element = 'selected' + side + 'Value';
    if (dire.selected) {
      if (this[element].indexOf(dire) < 0) {
        this[element].push(dire);
      }
    } else {
      this[element].splice(this[element].indexOf(dire), 1);
    }
  }

  addTodireList() {
    this.selectedLeftValue.forEach(item => {
      item.selected = false;
      this.direListAdded.push(item);
      this.direList.items.splice(this.direList.items.indexOf(item), 1);
    });

    this.selectedLeftValue = [];
    this.checkboxDireList = false;
  }

  deleteTodireList() {
    this.selectedRightValue.forEach(item => {
      item.selected = false;
      this.direList.items.push(item);
      this.direListAdded.splice(this.direListAdded.indexOf(item), 1);
    });

    this.selectedRightValue = [];
    this.checkboxDireListAdded = false
  }

  /**
   *
   * @param {IClientAdhesion} clientAdhesion
   */
  updateClientClientAdhesion(clientAdhesion: IClientAdhesion){
    this.clientAdhesionService.updateClientClientAdhesion(clientAdhesion, this.getPerson())
      .subscribe(res => {
        let clientAdhesion = this.clientAdhesionList.items.find(aux => aux.id === res.id);
        clientAdhesion.status = res.status;
      },
      error => {
        this.translate.get(error).subscribe((res: string) => {
          this.toastr.warning(res).then();
        });
      });
  }

  onCancelClientAdhesionClicked(clientAdhesion: IClientAdhesion){
    this.modalService.open(this.updateClientAdhesion).result.then((result) => {
      if (result === 'update') {
        this.updateClientClientAdhesion(clientAdhesion);
      }
    })
  }

  /**
   * Abre el panel modal de confirmación de acción
   */
  openConfirmAuth() {
    this.modalService.open(this.confirmAuthorization).result.then((result) => {
      if (result === 'createAuth') {
        this.saveClientAdhesion();
      }
    });
  }

  static createDefaultAdhesion() {
    return {
      direCode: '',
      invoicingServiceIdentifier: ''
    };
  }

  /**
   *
   * @return {IPerson}
   */
  getPerson(): IPerson {
    return this.loginService.getPerson();
  }

  onKeyUp(){
    this.subject.next();
  }

  onKeyUpAdhesion(){
    this.subjectAdhesion.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-adhesion-list/cli-adhesion-list.component.ts